/**
 * Purpose: Static Server Component — renders the centred logo + brand name
 * into the initial HTML stream with no JS, as a placeholder while
 * NavbarLinks lazy-loads on the client. Renders as `<header>` (banner
 * landmark) so the page has a non-empty banner even before hydration.
 * Inputs: `locale` used for the logo's home link.
 * Outputs: JSX; sits at z-40 so the full NavbarLinks (z-50, lazy-loaded)
 * visually overlays it once hydrated.
 */
import Image from 'next/image';
import Link from 'next/link';
import { LAM_LOGO_ID } from '@lib/constants';
import './navbarLoading.css';

export default function NavbarLoading({ locale }: { locale: string }) {
  return (
    <header id="navbar-loading" className="navbar-brand-nav">
      <div className="navbar-brand-inner">
        {/* Structural spacer — matches NavbarLinks left nav-link div for height parity */}
        <div className="navbar-brand-spacer">
          <div className="navbar-brand-spacer-inner" aria-hidden="true">
            <span className="nav-link">Loading</span>
          </div>
        </div>

        {/* The tagline span below carries the accessible name, so this logo
            image is decorative to avoid announcing it twice. */}
        <Link href={`/${locale}`} className="navbar-brand-link">
          <Image
            src={LAM_LOGO_ID}
            alt=""
            width={160}
            height={63}
            sizes="(max-width: 768px) 56px, 160px"
            className="navbar-brand-logo"
            priority
          />
          <span className="navbar-brand-tagline">
            Lynette Arlene Maven
          </span>
        </Link>

        {/* Structural spacer — matches NavbarLinks right nav-link div for height parity */}
        <div className="navbar-brand-spacer">
          <div className="navbar-brand-spacer-inner" aria-hidden="true">
            <span className="nav-link">Loading</span>
          </div>
        </div>
      </div>
    </header>
  );
}
